// Hook dodania pozycji do kalkulacji oferty –
// POST /sales-crm/clients/:cid/offers/:oid/calculations/:calcId/positions

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';
import type {
  CalculationPositionPriceType,
  ISalesCrmOfferCalculationPosition
} from 'api/endpoints/useGetSalesCrmOfferCalculationPositions';

export interface IPostSalesCrmOfferCalculationPositionPayload {
  name: string;
  productId?: number | null;
  serviceId?: number | null;
  priceType: CalculationPositionPriceType;
  priceNet: number;
  priceGross?: number | null;
  taxPercent?: number | null;
  /** Koszt własny netto — ile placimy dostawcy/wykonawcy (do realnej marzy). */
  costNet?: number | null;
}

export type IPostSalesCrmOfferCalculationPositionResponse = ICommandResponseSuccess &
  Partial<ISalesCrmOfferCalculationPosition>;

export const postSalesCrmOfferCalculationPosition = (
  clientId: number,
  offerId: string,
  calculationId: number,
  payload: IPostSalesCrmOfferCalculationPositionPayload
): Promise<IPostSalesCrmOfferCalculationPositionResponse> =>
  axios.post(
    `/sales-crm/clients/${clientId}/offers/${offerId}/calculations/${calculationId}/positions`,
    payload
  );

export const usePostSalesCrmOfferCalculationPosition = (
  clientId: number,
  offerId: string,
  calculationId: number,
  options?: UseMutationOptions<
    IPostSalesCrmOfferCalculationPositionResponse,
    IError,
    IPostSalesCrmOfferCalculationPositionPayload
  >
) =>
  useMutation(
    (payload: IPostSalesCrmOfferCalculationPositionPayload) =>
      postSalesCrmOfferCalculationPosition(clientId, offerId, calculationId, payload),
    options
  );
